//Core
import React from "react"

//Styles
import style from "./style.module.scss"

const { container, wrapper, title, table_img, annotation } = style

const Table = () => {
  return (
    <div className={container}>
      <div className={wrapper}>
        <h4 className={title}>
          Приклад розрахунку платежів під час Кредитних канікул
        </h4>
        <div
          className={table_img}
          dangerouslySetInnerHTML={{
            __html: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1173" height="604" viewBox="0 0 1173 604" style="font-family:'Roboto-Medium, Roboto !important'">
    <defs>
        <filter id="prefix__a" width="101.2%" height="104%" x="-.6%" y="-1.4%" filterUnits="objectBoundingBox">
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0212248689 0"/>
        </filter>
        <filter id="prefix__c" width="113.2%" height="128.8%" x="-6.6%" y="-14%" filterUnits="objectBoundingBox">
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="17"/>
            <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.118970788 0"/>
            <feMerge>
                <feMergeNode in="shadowMatrixOuter1"/>
                <feMergeNode in="SourceGraphic"/>
            </feMerge>
        </filter>
        <filter id="prefix__e" width="101.3%" height="102.8%" x="-.6%" y="-1%" filterUnits="objectBoundingBox">
            <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"/>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0212248689 0"/>
        </filter>
        <rect id="prefix__b" width="1123" height="349" x="0" y="0" rx="5"/>
        <path id="prefix__d" d="M21 0h1063.072c11.598 0 21 9.402 21 21v464.205c0 11.598-9.402 21-21 21H21c-11.598 0-21-9.402-21-21V21C0 9.402 9.402 0 21 0z"/>
        <style>
            @import url("https://fonts.googleapis.com/css?family=Roboto:400,500,700,900");
           
            *{
                font-family:"Roboto" !important; 
            }
            tspan {
                font-family:"Roboto-Medium, Roboto !important"
            }
        </style>
    </defs>
    <g fill="none" fill-rule="evenodd" transform="translate(34 2)">
        <use fill="#000" filter="url(#prefix__a)" xlink:href="#prefix__b"/>
        <use fill="#FFF" xlink:href="#prefix__b"/>
        <g filter="url(#prefix__c)" transform="translate(0 60)">
            <mask id="prefix__f" fill="#fff">
                <use xlink:href="#prefix__d"/>
            </mask>
            <use fill="#000" filter="url(#prefix__e)" xlink:href="#prefix__d"/>
            <use fill="#FFF" xlink:href="#prefix__d"/>
            <g mask="url(#prefix__f)">
                <g transform="translate(-9 100)">
                    <path fill="#F5F6FA" d="M0 0L1132.962 0 1132.962 149 0 149z" opacity=".626"/>
                    <rect width="149" height="49" x="39" y="26" fill="#3C569B" fill-rule="nonzero" opacity=".164" rx="13"/>
                    <rect width="149" height="49" x="39" y="174" fill="#B453E5" fill-rule="nonzero" opacity=".479" rx="13"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="52.262" y="45">Плановий платіж </tspan> <tspan x="52.262" y="64">(до Канікул)</tspan>
                    </text>
                    <text fill="#000"  font-family="Roboto !important;" font-size="14" font-weight="400">
                        <tspan x="52.262" y="127" font-family="Roboto !important;" font-size="14" font-weight="400">Всього за 3 місяці</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="381.299" y="127">1250,10</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="530.685" y="127">750,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="652.575" y="127">0,24</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="845.269" y="127">2000,13</tspan>
                    </text>
                    <path fill-rule="nonzero" stroke="#EAEEF7" stroke-linecap="square" d="M52.262 102H1062.11"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".597">
                        <tspan x="241.513" y="30.5">квітень</tspan> <tspan x="241.513" y="54.5">травень</tspan> <tspan x="241.513" y="78.5">червень</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".597">
                        <tspan x="389.066" y="31">416,70</tspan> <tspan x="389.066" y="55">416,70</tspan> <tspan x="389.066" y="79">416,70</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".597">
                        <tspan x="532.53" y="31">250,00</tspan> <tspan x="532.53" y="55">250,00</tspan> <tspan x="532.53" y="79">250,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".597">
                        <tspan x="652.575" y="31">0,08</tspan> <tspan x="652.575" y="55">0,08</tspan> <tspan x="652.575" y="79">0,08</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".847">
                        <tspan x="855.071" y="31">666,71</tspan> <tspan x="855.071" y="55">666,71</tspan> <tspan x="855.071" y="79">666,71</tspan>
                    </text>
                    <text fill="#4F525F" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".597">
                        <tspan x="1041.404" y="31">- - -</tspan> <tspan x="1041.404" y="55">- - -</tspan> <tspan x="1041.404" y="79">- - -</tspan>
                    </text>
                    <text fill="#71778D" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="1041.404" y="124">- - -</tspan>
                    </text>
                </g>
            </g>
            <g mask="url(#prefix__f)">
                <g transform="translate(-15 395)">
                    <path fill="#F5F6FA" d="M0 0L1132.962 0 1132.962 149 0 149z" opacity=".626"/>
                    <rect width="149" height="49" x="45" y="28" fill="#3C569B" fill-rule="nonzero" opacity=".164" rx="13"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="58.262" y="46">ПІСЛЯ Канікул </tspan> <tspan x="58.262" y="65">(липневий етап)</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="58.262" y="140">Всього за 3 місяці</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="387.299" y="140">1250,10</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="536.685" y="140">750,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="658.575" y="140">0,24</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="851.269" y="140">2000,13</tspan>
                    </text>
                    <path fill-rule="nonzero" stroke="#EAEEF7" stroke-linecap="square" d="M58.262 115H1068.11"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".602">
                        <tspan x="247.513" y="31.5"> </tspan> <tspan x="247.513" y="55.5">липень</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".602">
                         <tspan x="395.066" y="56">416,70</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".602">
                         <tspan x="538.53" y="56">250,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".602">
                         <tspan x="658.575" y="56">0,08</tspan>
                    </text>
                    <text font-family="Roboto-Regular, Roboto" font-size="14" opacity=".846">
                         <tspan x="847.181" y="56" fill="#000">1916,81</tspan> <tspan x="897.097" y="56" fill="#DC1111">*</tspan>
                    </text>
                    <text fill="#71778D" font-family="Roboto-Regular, Roboto" font-size="14">
                         <tspan x="1047.404" y="56">- - -</tspan>
                    </text>
                    <text fill="#71778D" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="1047.404" y="137">- - -</tspan>
                    </text>
                </g>
            </g>
            <g mask="url(#prefix__f)">
                <g transform="translate(28.49 249)">
                    <path fill="#FFF" d="M0 0L1047.962 0 1047.962 149 0 149z" opacity=".626"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="15.262" y="45">На ПЕРІОД </tspan> <tspan x="15.262" y="64">Канікул </tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="15.262" y="127">Всього за 3 місяці</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="493.685" y="127">750,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="615.575" y="127">0,24</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="816.505" y="127">750,24</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Medium, Roboto" font-size="14" font-weight="400">
                        <tspan x="973.548" y="127">1250,10</tspan>
                    </text>
                    <path fill-rule="nonzero" stroke="#EAEEF7" stroke-linecap="square" d="M15.262 102H1025.11"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".599">
                        <tspan x="204.513" y="30.5">квітень</tspan> <tspan x="204.513" y="54.5">травень</tspan> <tspan x="204.513" y="78.5">червень</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".599">
                        <tspan x="375.602" y="31">- - -</tspan> <tspan x="375.602" y="55">- - -</tspan> <tspan x="375.602" y="79">- - -</tspan>
                    </text>
                    <rect width="69" height="20" x="803.511" y="21" fill="#F1E0FA" fill-rule="nonzero" rx="10"/>
                    <rect width="69" height="20" x="803.511" y="45" fill="#F1E0FA" fill-rule="nonzero" rx="10"/>
                    <rect width="69" height="20" x="803.511" y="68" fill="#F1E0FA" fill-rule="nonzero" rx="10"/>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".599">
                        <tspan x="495.53" y="31">250,00</tspan> <tspan x="495.53" y="55">250,00</tspan> <tspan x="495.53" y="79">250,00</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".599">
                        <tspan x="615.575" y="31">0,08</tspan> <tspan x="615.575" y="55">0,08</tspan> <tspan x="615.575" y="79">0,08</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".85">
                        <tspan x="818.455" y="35">250,08</tspan> <tspan x="818.455" y="59">250,08</tspan> <tspan x="818.455" y="83">250,08</tspan>
                    </text>
                    <text fill="#000" font-family="Roboto-Regular, Roboto" font-size="14" opacity=".599">
                        <tspan x="982.455" y="31">416,70</tspan> <tspan x="982.455" y="55">416,70</tspan> <tspan x="982.455" y="79">416,70</tspan>
                    </text>
                    <text fill="#71778D" font-family="Roboto-Regular, Roboto" font-size="14">
                        <tspan x="375.602" y="124">- - -</tspan>
                    </text>
                </g>
            </g>
        </g>
        <text fill="#000" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold">
            <tspan x="44" y="96">Щомісячний платіж </tspan> <tspan x="44" y="112">за кредитом:</tspan>
        </text>
        <g fill="#000" fill-opacity=".888" font-family="Roboto-Bold, Roboto" font-size="14" font-weight="bold" letter-spacing=".2">
            <g>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="0" y="13">Графік </tspan> <tspan x="0" y="29">платежів</tspan> 
                </text>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="157.461" y="13">Тіло </tspan> <tspan x="131.153" y="29">кредит</tspan> <tspan x="179.48" y="29">у</tspan>
                </text>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="252.265" y="13">Щомісячна </tspan> <tspan x="279.149" y="29">комісі</tspan> <tspan x="321.118" y="29">я</tspan>
                </text>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="407.983" y="13">Проценти за </tspan> <tspan x="407.983" y="29">кредитом</tspan> 
                </text>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="614.307" y="13">Сума </tspan> <tspan x="559.99" y="29">щомісячного </tspan> <tspan x="591.49" y="45">платежу</tspan> 
                </text>
                <text transform="translate(236 80) translate(0 .615)">
                    <tspan x="782.18" y="13">Сума </tspan> <tspan x="696.484" y="29">відтермінованого </tspan> <tspan x="704.052" y="45">платежу під час </tspan> <tspan x="765.106" y="61">Канікул</tspan> 
                </text>
            </g>
        </g>
    </g>
</svg>
`,
          }}
        ></div>
        <div className={annotation}>
          <span>* </span>
          платіж в липні складатиметься з суми відтермінованого платежу за
          Канікули й суми щомісячного платежу
        </div>
      </div>
    </div>
  )
}

export default Table
